import React, { useEffect, useState } from "react";
import { ApiService } from "../../components/Common/ApiService";
import { isIdTarget } from '../../store/actions/todoActions';

import { LazyLoadImage } from "react-lazy-load-image-component";
import { useDispatch } from "react-redux";

import { Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import ConditionalRender from "../../components/Common/ConditionalRender";

import { useHandleClickLoading } from "../../components/Common/utils";

function AllGames() {
  const isWebSetting = localStorage.getItem('isWebSetting');
  const parseWebSetting = JSON.parse(isWebSetting);
  const [productData, setProductData] = useState([]);
  const [listProduct, setListProduct] = useState([]);

  const [productLoading, setProductLoading] = useState(true);
  const [tabcategroy, setTabCategory] = useState('Game');

  const dispatch = useDispatch();
  const handleClickLoading = useHandleClickLoading();

  useEffect(() => {
    fetchDataProduct();
    dispatch(isIdTarget(undefined));
  }, [dispatch]);

  const fetchDataProduct = async () => {
    setProductLoading(true);
    try {
      const response = await ApiService({
        baseurl: "user/kategori",
        method: "GET",
        XGORDON: "KATEGORI"
      });
      setProductLoading(false);
      if (response?.statusCode === 200) {
        setProductData(response?.result.data);
        setTabCategory(response?.result.data[0]?.jenis || "")

        const allCategory = response?.result.data.reduce((accumulator, current) => {
          return [...accumulator, ...current.kategori];
        }, []);
        const listProduct = allCategory.map((item) => {
          return {
            ...item,
            jenis: response?.result.data.find((jenis) =>
              jenis.kategori.some((kategori) => kategori.nama === item.nama)
            ).jenis,
          };
        });
        const slugArray = listProduct.map(item => item.slug);
        localStorage.setItem('isProduct', JSON.stringify(slugArray));

        setListProduct(listProduct);

      } else {
        setProductData([]);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  return (
    <div className="flex flex-col gap-3 flex-1">
      <div className="flex flex-row lg:rounded-lg rounded-none shadow-inner overflow-hidden bg-cardLight dark:bg-cardDark sm: min-h-[100px] relative">
        <div className="flex flex-col gap-2 justify-center flex-1 p-3">
          <span className="text-3xl  text-[#22BDE2] font-bold">Semua Game</span>
          <span className=" text-base font-light ">
            Ini adalah halaman untuk melihat semua produk kami. Silahkan pilih produk untuk Membelinya
          </span>
        </div>
        <div className="md:flex hidden flex-1">
          <img
            src={require('../../assets/images/pngwing 1.png')}
            alt="Logo"
            className="object-cover  object-right flex-1 h-40 " />
        </div>
      </div>
      <div className="flex flex-col  py-3 pt-0">
        <div className="flex relative overflow-x-scroll no-scrollbar h-9">
          <div className="flex flex-row absolute top-0 left-3 right-3 bottom-0">
            {productData.map((item, index) => {
              return (
                <div
                  key={index}
                  className={`flex  group bg-gradient-to-r  ${tabcategroy === item.jenis ? "from-[#22BDE2] to-[#FC00FF] " : "bg-[#D8E7FF] dark:bg-[#D8E7FF]"} px-4 p-2 items-center justify-center rounded-full mx-1`}
                >
                  <button
                    onClick={() => {
                      if (item.jenis === tabcategroy) {
                        setTabCategory(item.jenis);

                      } else {
                        setTabCategory(item.jenis);
                      }
                    }}
                    className="flex flex-1 flex-row items-center justify-center w-full h-full ">
                    <span className={`text-xs text-center whitespace-nowrap ${tabcategroy === item.jenis ? "text-darkColor " : ""} line-clamp- `}>
                      {item.jenis}
                    </span>
                  </button>
                </div>
              );
            })}
          </div>
        </div>
        {tabcategroy === '' ? null :
          <div className="flex flex-col gap-3">
            <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6 xl:grid-cols-7  gap-2 px-3 mt-2  pt-2 ">
              <ConditionalRender
                productsData={listProduct}
                isLoading={productLoading}
                model={"emptyData"}
              >
                {listProduct.map((item, index) => {
                  return (
                    tabcategroy === item.jenis &&
                    <div
                      key={index} className="flex flex-col overflow-hidden rounded-lg aspect-[1/1.3]">
                      <div
                        className="flex flex-col flex-1 h-full gap-1 group cursor-pointer"
                        onClick={() => {
                          handleClickLoading('/beli/' + item.slug)
                        }}>
                        <div className="relative flex flex-col bg-[#2121210f] dark:bg-[#f3f3f30f] flex-1 h-full overflow-hidden">
                          <LazyLoadImage
                            src={item.gambar}
                            alt={item.nama}
                            height={"100%"}
                            className=" w-full h-full object-cover group-hover:blur-xl"
                            effect="blur"
                          />
                          <div className="absolute w-full h-full hidden items-center justify-center group-hover:flex">
                            <img
                              src={parseWebSetting?.favicon}
                              alt="Logo"
                              width={'50%'}
                              height={'50%'}
                              className="white-filter"
                            />
                          </div>
                          <div className="absolute bottom-0 w-full bg-[#22bce2df] flex flex-col text-darkColor justify-center sm:h-11 h-9 ">
                            <span className=" sm:text-sm text-xs text-center line-clamp-2">
                              {item.nama}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </ConditionalRender>
            </div>
          </div>}
      </div>
    </div>
  );
}

export default AllGames;
